// Referral capture — reads ?ref= from URL, persists for the session, and exposes the value
// so forms can auto-populate the Referred By field.
//
// Format expected: ?ref=Name (URL-encoded). Examples that work the same:
//   ?ref=Donja%20Williams
//   ?ref=donja-friend
//   ?ref=jane+smith    (plus signs decoded as spaces)
// Slugs with hyphens are converted to spaces and Title-Cased for display.

const STORAGE_KEY = "fim_ref";
const MAX_LEN = 80;

function prettify(raw) {
  if (!raw) return "";
  let s = decodeURIComponent(String(raw).replace(/\+/g, " ")).trim();
  if (!s) return "";
  // If it looks like a slug (no spaces, contains hyphen/underscore), humanize.
  if (!/\s/.test(s) && /[-_]/.test(s)) {
    s = s.replace(/[-_]+/g, " ");
  }
  // Light Title Case (don't override if user already mixed-cased intentionally with a space).
  if (s === s.toLowerCase()) {
    s = s.replace(/\b\w/g, (c) => c.toUpperCase());
  }
  return s.slice(0, MAX_LEN);
}

export function captureReferrerFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (raw) {
      const name = prettify(raw);
      if (name) {
        sessionStorage.setItem(STORAGE_KEY, name);
        return name;
      }
    }
  } catch {
    // Non-browser env or blocked storage — no-op.
  }
  return getStoredReferrer();
}

export function getStoredReferrer() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function buildReferralLink(origin, name) {
  const base = (origin || "").replace(/\/+$/, "");
  const clean = String(name || "").trim().slice(0, MAX_LEN);
  if (!clean) return base + "/";
  return `${base}/?ref=${encodeURIComponent(clean)}`;
}
